import React from "react";

import { faChevronDown } from "@fortawesome/pro-regular-svg-icons";

import { Icon } from "src/design-system/Icon";

type ButtonProps = {
  value?: string;
};

export const EnvironmentDropdownButton: React.FC<ButtonProps> = ({ value }) => {
  return (
    <div className="flex items-center justify-between py-2 pr-3 pl-4">
      {value ? (
        <span>{value}</span>
      ) : (
        <span className="text-gray-500">Select credentials</span>
      )}
      <div className="flex h-auto items-center">
        <Icon icon={faChevronDown} size="xs" />
      </div>
    </div>
  );
};
